/**
 * Ações para redes sociais do site ODC.
 * @module actions/socialNetworks
 */

import { GET_SOCIAL_NETWORKS } from '../constants/ActionTypes';

export function getSocialNetworks() {
  return {
    type: GET_SOCIAL_NETWORKS,
    request: {
      op: 'get',
      path: '/@odcsite',
    },
  };
}
